<div class="save-status-container">
  @if ((loaded$ | async) === false) {
    <span translate="PRESENTER.SAVING"></span>
    <mat-spinner [diameter]="14"></mat-spinner>
  }

  @if (loaded$ | async) {
    <span translate="PRESENTER.SAVED"></span>
    <gb-icon height="14" [icon]="'checkmark-circle'"></gb-icon>
  }
</div>
